module.exports = __webpack_public_path__ + "img/yxbg.f1b954a7.png";